import { bus } from '@/main.js';
function edit_payment_info(){
    bus.$emit('payment-info',this.info);
}


export {
    edit_payment_info,
}